<div class="page-actions">
  <dv-button
    color="primary"
    icon="add"
    (click)="onCreateClick()"
    routerLink="new/information"
    [disabled]="(canAddPOI$ | async) === false">
    {{ 'General.Poi' | translate }}
  </dv-button>
  <dv-button (click)="onShowAllPoiClick()" [disabled]="disableMapBtn">
    {{ 'POI.ShowAllPoi' | translate | uppercase }}
  </dv-button>
</div>
<dv-vertical-splitter
  [resizableSide]="resizableSide.Right"
  id="poi-vertical-splitter">
  <div left-side>
    <app-poi-grid></app-poi-grid>
  </div>
  <div right-side>
    <router-outlet />
  </div>
</dv-vertical-splitter>
